import orangeAmount from "../../assets/orange-amount.png";
import greenAmount from "../../assets/green-amount.png";
import blueAmount from "../../assets/blue-amount.png";

export const details = [
  {
    title: "Total Commission",
    amount: "193035.00",
    icon: orangeAmount,
    growthClass: "text-green",
    backgroundClass: "orange",
  },
  {
    title: "Total Gift Commission ",
    amount: "2235.00",
    icon: greenAmount,
    growthClass: "text-green",
    backgroundClass: "green",
  },
  {
    title: "Total Chat/Call Commission",
    amount: "190800.00",
    icon: blueAmount,
    growthClass: "text-green",
    backgroundClass: "blue",
  }
 
];
